// Please note that to enable features or switches they must
// also be added to features.yml in the checkout code base
export default {
  DISABLE_PAYPAL: 'disable_paypal',
  DISABLE_GOOGLE_PAY: 'disable_google_pay',
  APPLE_PAY: 'apple_pay',
  USE_REAL_LOQATE_OVERRIDE: 'use_real_loqate_override',
  USE_LOCAL_PAYPAL_SANDBOX_OVERRIDE: 'use_local_paypal_sandbox_override',
  LOG_ANALYTICS: 'logAnalytics',
  ALLOW_MY_JL_SIGN_UPS: 'join_my_jl',
  SHOW_RECOMMENDATIONS: 'show_recommendations',
  LOG_APPLE_PAY_DATA: 'log_apple_pay',
  REQUEST_BILLING_ADDRESS_FROM_APPLE_PAY: 'request_billing_address_from_apple_pay',
  EXPRESS_APPLE_PAY: 'express_apple_pay',
  FORCE_CUSTOMER_APP_TYPE: 'force_customer_app_type',
  APPLE_PAY_DISABLED_FOR_APPS_GUESTS: 'apple_pay_disabled_for_apps_guests',
  SPEND_STRETCH_MESSAGING: 'spend_stretch_messaging',
  FREE_CLICK_COLLECT: 'free_click_collect',
  STREAMLINED_PAYMENTS: 'streamlined_payments',
  SHOW_LIMITED_COLLECTION_DAYS_MESSAGE: 'show_limited_collection_days_message',
  TITLE_DROPDOWN_ENABLED: 'title_dropdown_enabled',
  DEFAULT_DELIVERY_TAB_ENABLED: 'default_delivery_tab_enabled',
  DELIVERY_ACCESSIBILITY_INSTRUCTIONS_ENABLED: 'delivery_accessibility_instructions_enabled',
  PROMOTE_CLAIM_ORDER: 'promote_claim_order',
  TEST_CRYPTOGRAM_IN_INTEGRATION: 'test_cryptogram_in_integration',
  ALWAYS_SHOW_COLLECT_PLUS: 'always_show_collect_plus',
};
